export class AuditEditorFunction {
  static FUNCTION_LIST = new Set();
  static FUNCTION_MAP = {};
  static injectFun(opt) {
    if (!opt) return;
    if (this.FUNCTION_LIST.has(opt.callName)) {
      return console.warn("不能重复注入:" + opt.callName);
    }
    this.FUNCTION_LIST.add(opt.callName);
    this.FUNCTION_MAP[opt.callName] = opt;
  }

  static getAllFunTree(excludePrivate = true) {
    let groupMap = {};
    let groupList = [];
    this.FUNCTION_LIST.forEach((callName) => {
      const FUNCTION = this.FUNCTION_MAP[callName];
      if (!FUNCTION || (excludePrivate && FUNCTION.private)) return;
      if (!groupMap[FUNCTION.group]) {
        groupMap[FUNCTION.group] = {
          label: FUNCTION.group,
          children: [],
        };
        groupList.push(groupMap[FUNCTION.group]);
      }
      let obj = {
        label: `${FUNCTION.name} ${FUNCTION.callName}`,
        callName: FUNCTION.callName,
      };
      if (FUNCTION.afterContent) {
        obj.afterContent = FUNCTION.afterContent;
      }
      groupMap[FUNCTION.group].children.push(obj);
    });
    return groupList;
  }

  static getAllFunMap() {
    let map = {};
    this.FUNCTION_LIST.forEach((callName) => {
      const FUNCTION = this.FUNCTION_MAP[callName];
      if (!FUNCTION) return;
      map[FUNCTION.callName] = FUNCTION.handler;
    });
    return map;
  }
  constructor() {}
}

// -----------内部函数----------
AuditEditorFunction.injectFun({
  callName: "$$isFieldObj",
  name: "是否是变量块",
  group: "内部函数",
  private: true,
  handler(arg) {
    return !!arg?.jsField;
  },
});
AuditEditorFunction.injectFun({
  callName: "$$getDynamicFunction",
  name: "获取执行FUNC",
  group: "内部函数",
  private: true,
  handler(code) {
    let dynamicFunction = new Function("args", code);
    return dynamicFunction;
  },
});
AuditEditorFunction.injectFun({
  callName: "$$isGetCtrl",
  name: "是否是变量块",
  group: "内部函数",
  private: true,
  handler(arg) {
    return this.$$isFieldObj(arg) && arg.isGetCtrl;
  },
});
AuditEditorFunction.injectFun({
  callName: "$$getFieldValue",
  name: "获取变量块值",
  group: "内部函数",
  private: true,
  handler(arg) {
    if (!this.$$isFieldObj(arg)) {
      return arg;
    }
    const {
      tableName,
      field,
      isItemsCtrl,
      isGetAttach,
      isMultipleCtrl,
      isGetAreaSelectDetail,
    } = arg;

    let value = this.$viewData?.[`${tableName}.${field}`];
    if (isItemsCtrl) {
      if (isGetAttach) {
        let ctrl = this.$$getFieldCtrl(arg)?.component;
        let attachFullMaps = ctrl?.metadata?.dataSource?.attachFullMaps;
        if (attachFullMaps?.length) {
          let attach = attachFullMaps.find(
            (item) => item.value == value?.value
          );
          if (attach) {
            value = value[ctrl.attachField];
          } else {
            value = "";
          }
        } else {
          value = "";
        }
      } else if (isMultipleCtrl && dsf.isArray(value)) {
        value = value?.map((item) => item?.value) || [];
      } else if (isGetAreaSelectDetail) {
        value = value?.detail;
      } else {
        value = value?.value;
      }
    }
    return value ?? "";
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getCrossTableFieldValue",
  name: "获取跨表字段数据",
  group: "内部函数",
  private: true,
  handler(arg) {
    if (!this.$$isFieldObj(arg)) {
      return arg;
    }
    let { isItemsCtrl, isMultipleCtrl, tableName, field } = arg;
    if (isItemsCtrl) {
      return this.$crossTableData?.[`${tableName}.${field}_value`];
    }
    return this.$crossTableData?.[`${tableName}.${field}`];
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getFieldCtrl",
  name: "获取变量块值",
  group: "内部函数",
  private: true,
  handler(arg) {
    if (!this.$$isFieldObj(arg)) {
      return arg;
    }
    const { tableName, field, ctrlDesignId } = arg;
    let component =
      this.$allControls[`${tableName}.${field}`] ||
      this.$allControls[ctrlDesignId];
    return {
      jsField: true,
      isGetCtrl: true,
      component,
    };
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getSubFieldValue",
  name: "获取子表变量块值",
  group: "内部函数",
  private: true,
  handler(arg) {
    if (!this.$$isFieldObj(arg)) {
      return arg;
    }
    const {
      subTableName,
      field,
      isItemsCtrl,
      isMultipleCtrl,
      isGetAreaSelectDetail,
    } = arg;
    let tableValue = this.$$getSubTableData(subTableName);
    let fieldKey = `${subTableName}.${field}`;
    if (arg.isSumComputed) {
      let valList = [];
      tableValue?.forEach((row) => {
        valList.push(row[fieldKey] || 0);
      });
      return dsf.math.sum(valList);
    }
    let fieldIndexKey = `${subTableName}.$index`;
    let fieldRowIndex = this.$watchData[fieldIndexKey];
    let value = tableValue?.[fieldRowIndex][fieldKey];
    if (isItemsCtrl) {
      if (isMultipleCtrl && dsf.isArray(value)) {
        value = value?.map((item) => item?.value) || [];
      } else {
        value = value?.value;
      }
    } else if (isGetAreaSelectDetail) {
      value = value?.detail;
    }
    return value ?? "";
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getSetField",
  name: "获取变量集合",
  group: "内部函数",
  private: true,
  handler(arg) {
    return arg?.varList || [];
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getFieldSetTarget",
  name: "获取字段SetTarget",
  group: "内部函数",
  private: true,
  handler(arg) {
    if (!this.$$isFieldObj(arg)) {
      return arg;
    }
    const { tableName, field, isItemsCtrl } = arg;
    let attachField;
    let items = [];
    if (isItemsCtrl) {
      let res = this.$$getFieldCtrlItems(arg);
      if (this.$$isFieldObj(res)) {
        if (res.isCtrlItems) {
          items = res.items ?? [];
        }
        if (res.attachField) {
          attachField = res.attachField;
        }
      }
    }
    return {
      jsField: true,
      isSetTarget: true,
      isItemsCtrl,
      attachField,
      target: this.$viewData,
      targetKey: `${tableName}.${field}`,
      items,
    };
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getSubFieldRowIndex",
  name: "获取子表字段所在行数据Index",
  group: "内部函数",
  private: true,
  handler(field) {
    if (!this.$$isSubField(field)) return;
    const { subTableName } = field;
    let fieldIndexKey = `${subTableName}.$index`;
    return this.$watchData[fieldIndexKey];
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getSubFieldRow",
  name: "获取子表字段所在行数据",
  group: "内部函数",
  private: true,
  handler(field) {
    if (!this.$$isSubField(field)) return;
    let index = this.$$getSubFieldRowIndex(field);
    const { subTableName } = field;
    let tableValue = this.$viewData?.[subTableName] || [];
    return tableValue?.[index];
  },
});

AuditEditorFunction.injectFun({
  callName: "$$isSubField",
  name: "获取变量块值",
  group: "内部函数",
  private: true,
  handler(arg) {
    if (!this.$$isFieldObj(arg)) {
      return false;
    }
    return arg.isSubTable;
  },
});

AuditEditorFunction.injectFun({
  callName: "$$isSetTarget",
  name: "获取变量块值",
  group: "内部函数",
  private: true,
  handler(arg) {
    if (!this.$$isFieldObj(arg)) {
      return false;
    }
    return arg.isSetTarget;
  },
});
AuditEditorFunction.injectFun({
  callName: "$$isItemsCtrl",
  name: "获取变量块值",
  group: "内部函数",
  private: true,
  handler(arg) {
    if (!this.$$isFieldObj(arg)) {
      return false;
    }
    return arg.isItemsCtrl;
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getSubTableData",
  name: "获取子表值",
  group: "内部函数",
  private: true,
  handler(subTableName) {
    return this.$viewData[subTableName] || [];
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getMlSubFieldSetTarget",
  name: "获取子表值",
  group: "内部函数",
  private: true,
  handler(arg, code) {
    let { subTableName, field, isItemsCtrl } = arg;
    let targetRow = this.$$getMlSubCodeRow(arg, code);
    let targetKey = `${subTableName}.${field}`;
    let items = [];
    if (isItemsCtrl) {
      let res = this.$$getFieldCtrlItems(arg);
      if (this.$$isFieldObj(res) && res.isCtrlItems) {
        items = res.items ?? [];
      }
    }
    return {
      jsField: true,
      isSetTarget: true,
      isItemsCtrl,
      target: targetRow,
      targetKey,
      items,
    };
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getSubFieldSetTarget",
  name: "获取子表值",
  group: "内部函数",
  private: true,
  handler(arg) {
    let { subTableName, field, isItemsCtrl } = arg;
    let subTableData = this.$$getSubTableData(subTableName);
    let targetRow = subTableData[this.$watchData[`${subTableName}.$index`]];
    let targetKey = `${subTableName}.${field}`;
    let items = [];
    if (isItemsCtrl) {
      let res = this.$$getFieldCtrlItems(arg);
      if (this.$$isFieldObj(res) && res.isCtrlItems) {
        items = res.items ?? [];
      }
    }
    return {
      jsField: true,
      isSetTarget: true,
      isItemsCtrl,
      target: targetRow,
      targetKey,
      items,
    };
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getSubFieldCtrl",
  name: "获取子表值",
  group: "内部函数",
  private: true,
  handler(arg) {
    if (!this.$$isFieldObj(arg)) {
      return arg;
    }
    let { subTableName, field, ctrlDesignId } = arg;
    let subTableData = this.$$getSubTableData(subTableName);
    let targetRow = subTableData[this.$watchData[`${subTableName}.$index`]];
    if (!targetRow) {
      console.warn(`${subTableName}子表行号没找到`);
    }
    return {
      jsField: true,
      isGetCtrl: true,
      component:
        this.$allControls[`${subTableName}.${field}-${targetRow?.$hash}`] ||
        this.$allControls[ctrlDesignId],
    };
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getFieldCtrlItems",
  name: "获取子表值",
  group: "内部函数",
  private: true,
  handler(arg) {
    if (!this.$$isFieldObj(arg)) {
      return arg;
    }
    let { subTableName, tableName, field, isSubTable } = arg;
    let items = [];
    let attachField = this.$$getFieldCtrl(arg)?.component?.attachField;
    if (isSubTable) {
      items =
        this.$viewInitData?.[`${subTableName}.${field}`]?.dataSource ?? [];
    } else {
      items = this.$viewInitData?.[`${tableName}.${field}`]?.dataSource ?? [];
    }
    return {
      jsField: true,
      isCtrlItems: true,
      items,
      attachField,
    };
  },
});

AuditEditorFunction.injectFun({
  callName: "$$getMlSubFieldValue",
  name: "获取子表值",
  group: "内部函数",
  private: true,
  handler(arg, code) {
    let subRow = this.$$getMlSubCodeRow(arg, code);
    let { subTableName, field } = arg;
    return subRow?.[`${subTableName}.${field}`] ?? "";
  },
});
AuditEditorFunction.injectFun({
  callName: "$$getMlSubCodeRow",
  name: "获取目录字段实例",
  group: "内部函数",
  private: true,
  handler(arg, code) {
    if (!this.$$isFieldObj(arg)) {
      return arg;
    }
    let { subTableName, catalogCode, descType } = arg;
    let row;
    let subTableData = this.$$getSubTableData(subTableName);
    if (descType == "CATALOGFIELD") {
      // let parentCatalogCodeKey = `${subTableName}.stats_meta_parent_catalog_code`;
      let statsMetaCodeKey = `${subTableName}.stats_meta_code`;
      row = subTableData.find(
        (row) =>
          // row[parentCatalogCodeKey] == catalogCode &&
          code == row[statsMetaCodeKey]
      );
    } else if (descType == "UNITFIELD") {
      let statsMetaUnitValueKey = `${subTableName}.stats_meta_unit_text`;
      row = subTableData.find((row) => code == row[statsMetaUnitValueKey]);
    }
    return row;
  },
});
AuditEditorFunction.injectFun({
  callName: "$$getMlSubFieldCtrl",
  name: "获取目录字段实例",
  group: "内部函数",
  private: true,
  handler(arg, code) {
    if (!this.$$isGetCtrl(arg)) {
      return arg;
    }
    let { subTableName, field, ctrlDesignId } = arg;
    let subRow = this.$$getMlSubCodeRow(arg, code);
    let ctrl = {
      jsField: true,
      isGetCtrl: true,
      component: undefined,
    };
    if (subRow) {
      let controlsKey = `${subTableName}.${field}-${subRow?.$hash}`;
      let component =
        this.$allControls[controlsKey] || this.$allControls[ctrlDesignId];
      ctrl.component = component;
    }
    return ctrl;
  },
});
AuditEditorFunction.injectFun({
  callName: "$$array_develop",
  name: "数据展平",
  group: "内部函数",
  private: true,
  handler(args) {
    let arr = [];
    let cloneArgs = dsf.isArray(args) ? [...args] : [];
    while (cloneArgs?.length) {
      let it = cloneArgs.shift();
      if (Array.isArray(it)) {
        cloneArgs.unshift(...it);
      } else {
        arr.push(it);
      }
    }
    return arr;
  },
});

AuditEditorFunction.injectFun({
  callName: "$$callFuncArg",
  name: "执行函数参数",
  group: "内部函数",
  private: true,
  handler(exp, ...args) {
    if (dsf.isFunction(exp)) return exp(...args);
    return exp;
  },
});

// ----------通用函数（数学）-----------

AuditEditorFunction.injectFun({
  callName: "SETVALUE",
  name: "元素赋值",
  group: "通用函数",
  handler(expA, expB) {
    expA = this.$$callFuncArg(expA);
    expB = this.$$callFuncArg(expB);
    if (!this.$$isFieldObj(expA)) {
      return;
    }
    let setKey;
    let setTagert;
    if (this.$$isItemsCtrl(expA)) {
      let attachField = expA?.attachField;
      if (expA.isMultipleCtrl) {
        const valList = [];
        if (!dsf.isArray(expB)) {
          expB = [expB];
        }
        expB.forEach((key) => {
          let checkVal = key;
          let attachVal = key[1];
          if (dsf.isArray(key)) {
            checkVal = key[0];
          }
          let val;
          dsf.deepForEach(expA?.items || [], (item) => {
            if (item?.value == checkVal) {
              val = _.cloneDeep(item);
            }
          });
          if (val) {
            val[attachField] = attachVal ?? "";
            valList.push(val);
          }
        });
        expB = valList;
      } else {
        let checkVal = expB;
        let attachVal = expB[1];
        if (dsf.isArray(expB)) {
          checkVal = expB[0];
        }
        dsf.deepForEach(expA?.items || [], (item) => {
          if (item?.value == checkVal) {
            expB = _.cloneDeep(item);
          }
        });
        if (expB) expB[attachField] = attachVal ?? "";
      }
    }
    if (this.$$isSetTarget(expA)) {
      setTagert = expA.target;
      setKey = expA.targetKey;
    }
    setTagert && setKey && this.$form.$set(setTagert, setKey, expB);
  },
});

AuditEditorFunction.injectFun({
  callName: "TABLE2DROWCOLFILTER",
  name: "二维表格整列/整行过滤",
  group: "通用函数",
  handler() {
    // 空函数
  },
});

AuditEditorFunction.injectFun({
  callName: "UNCLEAR",
  name: "保留内容",
  group: "通用函数",
  handler() {
    // 空函数
  },
});

AuditEditorFunction.injectFun({
  callName: "ITEMATTACHTEXT",
  name: "获取选择项备注",
  group: "通用函数",
  handler(...args) {
    const [arg, val] = args.map((exp) => exp());
    if (!this.$$isItemsCtrl(arg)) {
      return arg;
    }
    const { isSubTable } = arg;
    let value = "";
    arg.isGetAttach = true;
    if (isSubTable) {
      value = this.$$getFieldValue(arg);
    } else {
      value = this.$$getFieldValue(arg);
    }
    return value ?? "";
  },
});

AuditEditorFunction.injectFun({
  callName: "AGE",
  name: "计算年龄",
  group: "通用函数",
  handler(...args) {
    const [sy, sm, ey, em] = args.map((exp) => exp());
    if (!sy || !sm) return 0;
    let stime = new Date(sy, sm - 1);
    let etime = new Date(new Date().getFullYear(), new Date().getMonth());
    if (ey && em) {
      etime = new Date(ey, em - 1);
    }
    return Math.floor((stime - etime) / 1000 / 60 / 60 / 24 / 365);
  },
});

AuditEditorFunction.injectFun({
  callName: "SUM",
  name: "求和",
  group: "通用函数",
  handler(...args) {
    let valList = args.map((exp) => this.$$callFuncArg(exp) || 0);
    return dsf.math.sum(valList) || 0;
  },
});

AuditEditorFunction.injectFun({
  callName: "YW_COMPAREROW",
  name: "同目录项条件计算",
  group: "通用函数",
  handler() {
    // 无需实现
  },
});

AuditEditorFunction.injectFun({
  callName: "SUMIFAND",
  name: "满足条件求和",
  group: "通用函数",
  handler(...args) {
    let targetProp = this.$$callFuncArg(args[1]);
    if (!this.$$isFieldObj(targetProp)) {
      return 0;
    }
    const { subTableName } = targetProp;
    const subTableData = this.$$getSubTableData(subTableName);
    let sumList = [];
    for (let i = 0; i < subTableData.length; i++) {
      const expressionFunc = this.$$getDynamicFunction(`
          with (args) {
            return (${args[0]})()
          }
      `);
      const row = subTableData[i];
      const $watchData = Object.assign({}, this.$watchData);
      $watchData[`${subTableName}.$hash`] = row.$hash;
      $watchData[`${subTableName}.$index`] = row.$index;
      $watchData[`${subTableName}.$order`] = row.$order;
      let res = expressionFunc(Object.assign({}, this, { $watchData }));
      if (res) {
        const expressionFunc = this.$$getDynamicFunction(`
            with (args) {
              return (${args[1]})()
            }
        `);
        sumList.push(
          expressionFunc(Object.assign({}, this, { $watchData })) || 0
        );
      }
    }
    return dsf.math.sum(sumList) || 0;
  },
});

AuditEditorFunction.injectFun({
  callName: "COUNT",
  name: "算条数",
  group: "通用函数",
  handler(...args) {
    let [targetProp] = args.map((exp) => this.$$callFuncArg(exp));
    if (!this.$$isFieldObj(targetProp)) {
      return 0;
    }
    const { subTableName } = targetProp;
    const subTableData = this.$$getSubTableData(subTableName);
    return subTableData?.length || 0;
  },
});

AuditEditorFunction.injectFun({
  callName: "COUNTIF",
  name: "判断算条数",
  group: "通用函数",
  handler(...args) {
    let targetProp = this.$$callFuncArg(args[1]);
    if (!this.$$isFieldObj(targetProp)) {
      return 0;
    }
    const { subTableName } = targetProp;
    const subTableData = this.$$getSubTableData(subTableName);
    let sum = 0;
    for (let i = 0; i < subTableData.length; i++) {
      const expressionFunc = this.$$getDynamicFunction(`
          with (args) {
            return (${args[0]})()
          }
      `);
      const row = subTableData[i];
      const $watchData = Object.assign({}, this.$watchData);
      $watchData[`${subTableName}.$hash`] = row.$hash;
      $watchData[`${subTableName}.$index`] = row.$index;
      $watchData[`${subTableName}.$order`] = row.$order;
      let res = expressionFunc(Object.assign({}, this, { $watchData }));
      if (res) {
        sum++;
      }
    }
    return sum;
  },
});

AuditEditorFunction.injectFun({
  callName: "ABS",
  name: "绝对值",
  group: "通用函数",
  handler(exp) {
    let num = Math.abs(this.$$callFuncArg(exp));
    if (Number.isNaN(num)) return "";
    return num;
  },
});

AuditEditorFunction.injectFun({
  callName: "ADD",
  name: "加",
  group: "通用函数",
  handler(exp1, exp2) {
    let res = dsf.math
      .add(this.$$callFuncArg(exp1) || 0, this.$$callFuncArg(exp2) || 0)
      .toNumber();
    if (!dsf.isNumber(res)) return undefined;
    return res;
  },
});

AuditEditorFunction.injectFun({
  callName: "AVG",
  name: "平均值",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    let valDevelops = this.$$array_develop(Array.from(args));
    valDevelops = valDevelops.map((it) => it || 0);
    return dsf.math.sum(...valDevelops) / valDevelops.length;
  },
});
AuditEditorFunction.injectFun({
  callName: "VERIFYCODE",
  name: "组织机构代码编码验证",
  group: "通用函数",
  handler(...args) {
    let [value] = args.map((exp) => this.$$callFuncArg(exp));
    if (value == "") {
      return false;
    } else if (value.length != 10) {
      return false;
    } else {
      var reg = /[0-9A-HJ-NPQRTUWXY]{8}-[0-9A-HJ-NPQRTUWXY]/;
      if (reg.test(value) == false) {
        return false;
      } else {
        var regLast = /^[0-9X]+$/;

        var lastnum = value.substring(9, 10);

        if (regLast.test(lastnum) == false) {
          // alert("组织统一社会信用代码最后一位只可为数字或大写拉丁字母:X");
          // callback(
          //   new Error("组织统一社会信用代码最后一位只可为数字或大写拉丁字母 X")
          // );
          return false;
        } else {
          let value1 = value;
          let value2 = value;
          let newValue = value1.substring(0, 8) + value2.substring(9, 10);
          var ancode;
          var ancodeWeightValue;
          var sum = 0;
          var weightedArray = [3, 7, 9, 10, 5, 8, 4, 2]; //加权因子
          var str = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          for (var i = 0; i < newValue.length - 1; i++) {
            ancode = newValue.substring(i, i + 1);
            ancodeWeightValue = str.indexOf(ancode);
            sum = sum + ancodeWeightValue * weightedArray[i];
          }
          var rightLastnum = 11 - (sum % 11);
          if (rightLastnum == 10) rightLastnum = "X";
          if (rightLastnum == 11) rightLastnum = "0";
          if (lastnum != rightLastnum) {
            return false;
          } else {
            return true;
          }
        }
      }
    }
  },
});
AuditEditorFunction.injectFun({
  callName: "VERIFYCREDITCODE",
  name: "统一社会信用代码校验",
  group: "通用函数",
  handler(...args) {
    let [str] = args.map((exp) => this.$$callFuncArg(exp));
    return new Tyshyxdm().verify(str);
  },
});
AuditEditorFunction.injectFun({
  callName: "ISPHONE",
  name: "电话判断",
  group: "通用函数",
  handler(...args) {
    let [phone] = args.map((exp) => this.$$callFuncArg(exp));
    return dsf.validate.map.isMobileOrTelPhone(phone);
  },
});

AuditEditorFunction.injectFun({
  // 1 省级行政区划 , 2 地级行政区划,3 县级行政区划,4 乡、镇（街道）,5 乡 ,6 居委会, 7 门号
  callName: "SUBREGIONALISMCODE",
  name: "截取行政区划代码",
  group: "通用函数",
  handler(...args) {
    let [str, num] = args.map((exp) => this.$$callFuncArg(exp));
    if (!str) return str;
    if (num == 1) {
      str = str.slice(0, 2);
    } else if (num == 2) {
      str = str.slice(2, 4);
    } else if (num == 3) {
      str = str.slice(4, 6);
    } else if (num == 4) {
      str = str.slice(6);
    } else if (num == 5) {
      str = str.slice(6, 9);
    } else if (num == 6) {
      str = str.slice(9);
    }
    return str;
  },
});
AuditEditorFunction.injectFun({
  callName: "YEAR",
  name: "判断年",
  group: "通用函数",
  handler(...args) {
    let [str, type = "1"] = args.map((exp) => this.$$callFuncArg(exp));
    let c_m = +this.$viewData[this.$tableName + ".stat_tab_year"];
    if (_.isNaN(str) || _.isNaN(c_m)) return false;
    if (type == 0) {
      return 1800 <= str && str <= c_m;
    } else if (type == 2) {
      return c_m <= str;
    }
    return 1800 <= str;
  },
});
AuditEditorFunction.injectFun({
  callName: "INDEX_OF",
  name: "是否存在位置",
  group: "通用函数",
  handler(...args) {
    let [str, rg] = args.map((exp) => this.$$callFuncArg(exp));
    return str.includes(rg) ?? false;
  },
});

AuditEditorFunction.injectFun({
  callName: "CBRT",
  name: "立方根",
  group: "通用函数",
  handler(exp) {
    return dsf.math.sqrt(this.$$callFuncArg(exp) || 0, 3, 0);
  },
});

AuditEditorFunction.injectFun({
  callName: "CEIL",
  name: "向上取整",
  group: "通用函数",
  handler(exp) {
    let num = Math.ceil(this.$$callFuncArg(exp));
    if (Number.isNaN(num)) return "";
    return num;
  },
});

AuditEditorFunction.injectFun({
  callName: "DIV",
  name: "除以",
  group: "通用函数",
  handler(expA, expB) {
    expA = this.$$callFuncArg(expA) || 0;
    expB = this.$$callFuncArg(expB) || 0;
    return expB === 0 ? 0 : dsf.math.div(expA, expB).toNumber();
  },
});

AuditEditorFunction.injectFun({
  callName: "GEOMETRICMEAN",
  name: "几何平均数",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    let nums = Array.from(args);
    return this.SUM(nums) / nums.length;
  },
});

AuditEditorFunction.injectFun({
  callName: "CLEAR",
  name: "清空内容",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    args.forEach((arg) => {
      if (this.$$isSetTarget(arg)) {
        let { target, targetKey } = arg;
        this.$form.$set(target, targetKey, undefined);
      }
    });
  },
});

AuditEditorFunction.injectFun({
  callName: "LIST_VARIABLE",
  name: "变量集合判断",
  group: "通用函数",
  handler(...args) {
    let [val, list] = args.map((exp) => this.$$callFuncArg(exp));
    return list.some((it) => it == val);
  },
});

//-----------通用函数（逻辑判断）-------------
AuditEditorFunction.injectFun({
  callName: "AND",
  name: "并且",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    for (let i = 0; i < args.length; i++) {
      if (!args[i]) {
        return false;
      }
    }
    return true;
  },
});

AuditEditorFunction.injectFun({
  callName: "IF",
  name: "判断",
  group: "通用函数",
  handler(exp, trueExp, falseExp) {
    if (this.$$callFuncArg(exp)) {
      return this.$$callFuncArg(trueExp);
    } else {
      if (falseExp === undefined) {
        return true;
      }
      return this.$$callFuncArg(falseExp);
    }
  },
});

AuditEditorFunction.injectFun({
  callName: "EQUALS",
  name: "相等",
  group: "通用函数",
  handler(...args) {
    let [exp1, exp2] = args.map((exp) => this.$$callFuncArg(exp));
    return exp1 == exp2;
  },
});

AuditEditorFunction.injectFun({
  callName: "GREATERTHAN",
  name: "大于",
  group: "通用函数",
  handler(expA, expB) {
    return this.$$callFuncArg(expA) > this.$$callFuncArg(expB);
  },
});
AuditEditorFunction.injectFun({
  callName: "VERIFYIDCARD",
  name: "身份证验证",
  group: "通用函数",
  handler(str) {
    return dsf.idCard(this.$$callFuncArg(str)).type;
  },
});

AuditEditorFunction.injectFun({
  callName: "GREATERTHANEQUALS",
  name: "大于等于",
  group: "通用函数",
  handler(expA, expB) {
    return this.$$callFuncArg(expA) >= this.$$callFuncArg(expB);
  },
});
AuditEditorFunction.injectFun({
  callName: "ISCH",
  name: "中文判断",
  group: "通用函数",
  handler(exp) {
    return /^[\u4e00-\u9fa5]+$/.test(this.$$callFuncArg(exp));
  },
});
AuditEditorFunction.injectFun({
  callName: "ISEN",
  name: "英文判断",
  group: "通用函数",
  handler(exp) {
    return /^[a-zA-Z]+$/.test(this.$$callFuncArg(exp));
  },
});
AuditEditorFunction.injectFun({
  callName: "ISLOWER",
  name: "小写判断",
  group: "通用函数",
  handler(exp) {
    return !/[A-Z]/g.test(this.$$callFuncArg(exp));
  },
});
AuditEditorFunction.injectFun({
  callName: "ISNULL",
  name: "空值判断",
  group: "通用函数",
  handler(exp) {
    let str = this.$$callFuncArg(exp);
    return str === "" || str === undefined || str === null || str !== str;
  },
});
AuditEditorFunction.injectFun({
  callName: "ISNUM",
  name: "数字组成判断",
  group: "通用函数",
  handler(exp) {
    return dsf.isNumber(this.$$callFuncArg(exp));
  },
});

AuditEditorFunction.injectFun({
  callName: "ISUPPER",
  name: "大写判断",
  group: "通用函数",
  handler(exp) {
    return /^[A-Z]+$/.test(this.$$callFuncArg(exp));
  },
});

AuditEditorFunction.injectFun({
  callName: "LESSTHAN",
  name: "小于",
  group: "通用函数",
  handler(expA, expB) {
    return this.$$callFuncArg(expA) < this.$$callFuncArg(expB);
  },
});

AuditEditorFunction.injectFun({
  callName: "LESSTHANEQUALS",
  name: "小于等于",
  group: "通用函数",
  handler(expA, expB) {
    return this.$$callFuncArg(expA) <= this.$$callFuncArg(expB);
  },
});

AuditEditorFunction.injectFun({
  callName: "LOOKAT",
  name: "匹配位置",
  group: "通用函数",
  handler(rg, str) {
    rg = this.$$callFuncArg(rg);
    str = this.$$callFuncArg(str);
    let r = new RegExp(rg).exec(str);
    if (!r) return -1;
    return r.index;
  },
});

AuditEditorFunction.injectFun({
  callName: "LOWER",
  name: "转小写",
  group: "通用函数",
  handler(str) {
    return this.$$callFuncArg(str)?.toLocaleLowerCase() ?? "";
  },
});
AuditEditorFunction.injectFun({
  callName: "MATCH",
  name: "字符串匹配",
  group: "通用函数",
  handler(rg, str) {
    return (
      new RegExp(this.$$callFuncArg(rg))?.test(this.$$callFuncArg(str)) ?? false
    );
  },
});

AuditEditorFunction.injectFun({
  callName: "MAX",
  name: "最大值",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));

    return Math.max(...this.$$array_develop(args).map((it) => it || 0));
  },
});
AuditEditorFunction.injectFun({
  callName: "LEFT",
  name: "截取",
  group: "通用函数",
  handler(...args) {
    let [str, num] = args.map((exp) => this.$$callFuncArg(exp));
    num = +num;
    if (Number.isNaN(num)) return "";
    return str.substring(0, num);
  },
});

AuditEditorFunction.injectFun({
  callName: "MAXINDEX",
  name: "最大索引",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    return args.indexOf(this.MAX(...args));
  },
});

AuditEditorFunction.injectFun({
  callName: "MID",
  name: "字符串截取",
  group: "通用函数",
  handler(str, sNum, len) {
    str = this.$$callFuncArg(str);
    sNum = +this.$$callFuncArg(sNum);
    len = +this.$$callFuncArg(len);
    if (_.isNaN(sNum)) return "";
    sNum -= 1;
    if (sNum <= 0) sNum = 1;
    if (_.isNaN(len)) {
      len = undefined;
    } else {
      len += sNum;
    }
    return str?.substring?.(sNum, len) ?? "";
  },
});

AuditEditorFunction.injectFun({
  callName: "MIN",
  name: "最小值",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    return Math.min(...this.$$array_develop(args).map((it) => it || 0));
  },
});
AuditEditorFunction.injectFun({
  callName: "MININDEX",
  name: "最小索引",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    return args.indexOf(this.MIN(...args));
  },
});
AuditEditorFunction.injectFun({
  callName: "MINVALUE",
  name: "获取最小值",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    return this.MIN(...this.$$array_develop(args).map((it) => it || 0));
  },
});
AuditEditorFunction.injectFun({
  callName: "MAXVALUE",
  name: "获取最大值",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    return this.MAX(...this.array_develop(args));
  },
});
AuditEditorFunction.injectFun({
  callName: "NOTINLIST",
  name: "不在集合中",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    let target = args.splice(0, 1)[0];
    let argsLen = args.length;
    for (let i = 0; i < argsLen; i++) {
      const arg = args[i];
      let state;
      // 如果第二位参数是数组，则只会匹配第二个参数
      if (dsf.isArray(arg)) {
        state = arg.some((item) => item == target);
      } else {
        state = arg == target;
      }
      if (state) return false;
    }
    return true;
  },
});
AuditEditorFunction.injectFun({
  callName: "INLIST",
  name: "在集合中",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    let target = args.splice(0, 1)[0];
    let argsLen = args.length;
    for (let i = 0; i < argsLen; i++) {
      const arg = args[i];
      let state;
      // 如果第二位参数是数组，则只会匹配第二个参数
      if (dsf.isArray(arg)) {
        state = arg.some((item) => item == target);
      } else {
        state = arg == target;
      }
      if (state) return state;
    }
    return false;
  },
});
AuditEditorFunction.injectFun({
  callName: "INRANGE",
  name: "在其中",
  group: "通用函数",
  handler(...args) {
    let [str, strA, strB] = args.map((exp) => this.$$callFuncArg(exp));
    return strA >= str && str <= strB;
  },
});
AuditEditorFunction.injectFun({
  callName: "BGQ",
  name: "报告期偏移",
  group: "通用函数",
  handler() {
    // 空函数
  },
});
AuditEditorFunction.injectFun({
  callName: "ZDBGQ",
  name: "指定报告期偏移",
  group: "通用函数",
  handler(...args) {
    let [field] = args.map((exp) => this.$$callFuncArg(exp));
    // 空函数
    // console.log(field);
    return this.$$getCrossTableFieldValue(field);
  },
});
AuditEditorFunction.injectFun({
  callName: "TQSJ",
  name: "同期实际",
  group: "通用函数",
  handler(...args) {
    let [field] = args.map((exp) => this.$$callFuncArg(exp));
    return this.$$getCrossTableFieldValue(field);
    //TODO
  },
});
AuditEditorFunction.injectFun({
  callName: "BQSJ",
  name: "本期实际",
  group: "通用函数",
  handler(...args) {
    let [field] = args.map((exp) => this.$$callFuncArg(exp));
    return this.$$getCrossTableFieldValue(field);
    //TODO
  },
});
AuditEditorFunction.injectFun({
  callName: "CHANGE_BEFORE",
  name: "获取修改前的值",
  group: "通用函数",
  handler(...args) {
    const expressFunc = this.$$getDynamicFunction(`
      with (args) {
        return (${args[0]})()
      }  
    `);
    let funcArgs = Object.assign({}, this, {
      $viewData: this.$serverRequestData,
    });
    return expressFunc(funcArgs);
  },
});
AuditEditorFunction.injectFun({
  callName: "LEN",
  name: "文本字符长度",
  group: "通用函数",
  handler(...args) {
    let [str] = args.map((exp) => this.$$callFuncArg(exp));
    return str?.length ?? 0;
  },
});
AuditEditorFunction.injectFun({
  callName: "ISNUMBER",
  name: "数值判断",
  group: "通用函数",
  handler(...args) {
    let [str] = args.map((exp) => this.$$callFuncArg(exp));
    return /^[+-]?\d+(\.\d+)?$/.test(str.toString());
  },
});
AuditEditorFunction.injectFun({
  callName: "MOD",
  name: "求模",
  group: "通用函数",
  handler(...args) {
    let [v1, v2] = args.map((exp) => this.$$callFuncArg(exp));
    return v1 % v2;
  },
});
AuditEditorFunction.injectFun({
  callName: "MUL",
  name: "乘以",
  group: "通用函数",
  handler(...args) {
    let [v1, v2] = args.map((exp) => this.$$callFuncArg(exp));
    return dsf.math.mul(v1 || 0, v2 || 0).toNumber();
  },
});
AuditEditorFunction.injectFun({
  callName: "NOT",
  name: "求反",
  group: "通用函数",
  handler(...args) {
    let [logic] = args.map((exp) => this.$$callFuncArg(exp));
    return !logic;
  },
});

AuditEditorFunction.injectFun({
  callName: "SCALE_HALF_UP",
  name: "四舍五入保留小数",
  group: "通用函数",
  handler(...args) {
    let [num, accuracy] = args.map((exp) => this.$$callFuncArg(exp));
    if (dsf.isNumber(num) && dsf.isNumber(accuracy)) {
      const factor = Math.pow(10, accuracy);
      return Math.round(num * factor) / factor;
    }
    return num;
  },
});

AuditEditorFunction.injectFun({
  callName: "SCALE_DOWN",
  name: "舍弃末尾保留小数",
  group: "通用函数",
  handler(...args) {
    let [num, accuracy] = args.map((exp) => this.$$callFuncArg(exp));
    if (dsf.isNumber(num) && dsf.isNumber(accuracy)) {
      const factor = Math.pow(10, accuracy);
      return Math.floor(num * factor) / factor;
    }
    return num;
  },
});

AuditEditorFunction.injectFun({
  callName: "SURVEY_RANDOM",
  name: "随机码",
  group: "通用函数",
  handler(...args) {
    let [num] = args.map((exp) => this.$$callFuncArg(exp));
    if (dsf.isNumber(num) && dsf.isNumber(accuracy)) {
      const digits = "0123456789";
      let randomCode = "";
      for (let i = 0; i < num; i++) {
        const randomIndex = Math.floor(Math.random() * digits.length);
        randomCode += digits[randomIndex];
      }
      return randomCode;
    }
    return num;
  },
});

AuditEditorFunction.injectFun({
  callName: "NOTEQUAL",
  name: "不等",
  group: "通用函数",
  handler(...args) {
    let [v1, v2] = args.map((exp) => this.$$callFuncArg(exp));
    return v1 != v2;
  },
});
AuditEditorFunction.injectFun({
  callName: "NOTNULL",
  name: "非空",
  group: "通用函数",
  handler(exp) {
    let str = this.$$callFuncArg(exp);
    return str !== "" && str !== undefined && str !== null;
  },
});
AuditEditorFunction.injectFun({
  callName: "OR",
  name: "或者",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    for (let i = 0; i < args.length; i++) {
      if (args[i]) return true;
    }
    return false;
  },
});
AuditEditorFunction.injectFun({
  callName: "LIKE",
  name: "包含",
  group: "通用函数",
  handler(...args) {
    const [val, target] = args.map((exp) => this.$$callFuncArg(exp));
    if (dsf.isString(val) && dsf.isString(target)) {
      return val?.includes("target");
    }
    return false;
  },
});
AuditEditorFunction.injectFun({
  callName: "NOT_LIKE",
  name: "不包含",
  group: "通用函数",
  handler(...args) {
    const [val, target] = args.map((exp) => this.$$callFuncArg(exp));
    if (dsf.isString(val) && dsf.isString(target)) {
      return !val.includes("target");
    }
    return false;
  },
});
AuditEditorFunction.injectFun({
  callName: "START_WITH",
  name: "前匹配",
  group: "通用函数",
  handler(...args) {
    const [val, target] = args.map((exp) => this.$$callFuncArg(exp));
    if (dsf.isString(val) && dsf.isString(target)) {
      return val.indexOf("target") == 0;
    }
    return false;
  },
});
AuditEditorFunction.injectFun({
  callName: "NOT_START_WITH",
  name: "非前匹配",
  group: "通用函数",
  handler(...args) {
    const [val, target] = args.map((exp) => this.$$callFuncArg(exp));
    if (dsf.isString(val) && dsf.isString(target)) {
      return val.indexOf("target") != 0;
    }
    return false;
  },
});

AuditEditorFunction.injectFun({
  callName: "POWER",
  name: "幂函数",
  group: "通用函数",
  handler(...args) {
    let [num, num2] = args.map((exp) => this.$$callFuncArg(exp));
    return Math.pow(num, num2);
  },
});
AuditEditorFunction.injectFun({
  callName: "REPEAT",
  name: "重复校验",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    let typeMap = new Set();
    for (let i = 0; i < args.length; i++) {
      if (typeMap.has(args[i])) return true;
      typeMap.add(args[i]);
    }
    return false;
  },
});
AuditEditorFunction.injectFun({
  callName: "REPLACEALL",
  name: "全部替换",
  group: "通用函数",
  handler(...args) {
    let [str, rg, rStr, flags] = args.map((exp) => this.$$callFuncArg(exp));
    return str?.replace(new RegExp(rg, flags ?? ""), rStr) ?? "";
  },
});
AuditEditorFunction.injectFun({
  callName: "RIGHT",
  name: "右边提取",
  group: "通用函数",
  handler(...args) {
    let [str, start] = args.map((exp) => this.$$callFuncArg(exp));
    return str?.substring?.(str.length - start) ?? "";
  },
});
AuditEditorFunction.injectFun({
  callName: "CONCAT",
  name: "拼接",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    let typeMap = {};
    for (let i = 0; i < args.length; i++) {
      typeMap[dsf.type(args[i])] = dsf.type(args[i]);
    }
    if (Object.keys(typeMap).length > 1) {
      return null;
    }
    if (typeMap["array"]) {
      let r = [];
      args.forEach((it) => r.concat(it));
      return r;
    }
    if (typeMap["string"]) {
      let s = "";
      args.forEach((it) => (s += it));
      return s;
    }
    return null;
  },
});
AuditEditorFunction.injectFun({
  callName: "SUBSTR",
  name: "字符串截取",
  group: "通用函数",
  handler(...args) {
    let [str, start, len] = args.map((exp) => this.$$callFuncArg(exp));
    return str?.substring?.(start, start + len) ?? "";
  },
});
AuditEditorFunction.injectFun({
  callName: "CURRENTTIME",
  name: "获取当前时间",
  group: "通用函数",
  /**
   * CURRENTTIME 获取当前时间
   * 获取当前系统时间函数：
   * 年的表示形式yyyy
   * 月的表示形式MM
   * 日的表示形式dd
   * 时的表示形式HH
   * 分的表示形式mm
   * 秒的表示形式ss
   * 如：yyyy-MM-dd HH:mm:ss
   * 如：yyyy/MM/dd HH:mm:ss
   * 如：yyyy年MM月dd日HH时mm分ss秒
   * @param {string} format
   * @returns {string}
   * CURRENTTIME('yyyy') 2022
   * CURRENTTIME('yyyy-MM') 2020-01
   * CURRENTTIME('yyyy-MM-dd) 2020-01-01
   * CURRENTTIME('yyyy-MM-dd HH:mm:ss')  2020-01-01 20:30:00
   */
  handler(...args) {
    let [format] = args.map((exp) => this.$$callFuncArg(exp));
    format = format
      .replace(/mm/g, "ii")
      .replace(/MM/g, "mm")
      .replace(/HH/g, "hh");
    return dsf.date.format(new Date(), format);
  },
});

AuditEditorFunction.injectFun({
  callName: "ISLEADER",
  name: "单位负责人判断",
  group: "通用函数",
  handler(...args) {
    let [name] = args.map((exp) => this.$$callFuncArg(exp));
    const regex = /^(?=.*[\u4e00-\u9fa5]{2,})[\u4e00-\u9fa5a-zA-Z\s\.\-]+$|^[a-zA-Z]+(?:[\s\.\-]?[a-zA-Z]+)*$/;
    return regex.test(name);
  },
});
AuditEditorFunction.injectFun({
  callName: "CASE",
  name: "条件过滤",
  group: "通用函数",
  handler(...args) {
    let i = 0;
    let argsLen = args.length;
    while (i < argsLen) {
      let caseFn = this.$$callFuncArg(args[i]);
      if (caseFn) {
        return this.$$callFuncArg(args[i + 1]);
      }
      i += 2;
    }
    return true;
  },
});
AuditEditorFunction.injectFun({
  callName: "ROUND",
  name: "四舍五入取整",
  group: "通用函数",
  handler(num) {
    return Math.round(this.$$callFuncArg(num));
  },
});
AuditEditorFunction.injectFun({
  callName: "SQRT",
  name: "平方根",
  group: "通用函数",
  handler(num) {
    return dsf.math.sqrt(this.$$callFuncArg(num) || 0, 2, 0);
  },
});
AuditEditorFunction.injectFun({
  callName: "SUB",
  name: "减",
  group: "通用函数",
  handler(v1, v2) {
    return dsf.math
      .sub(this.$$callFuncArg(v1) || 0, this.$$callFuncArg(v2) || 0)
      .toNumber();
  },
});

AuditEditorFunction.injectFun({
  callName: "FIND",
  name: "查找",
  group: "通用函数",
  handler(expA, expText, expStart) {
    let express = this.$$callFuncArg(expA);
    let text = this.$$callFuncArg(expText);
    let start = this.$$callFuncArg(expStart);
    start = +start;
    if (!express || !text || Number.isNaN(start)) return false;
    const re = new RegExp(express);
    let r = re.exec(text);
    if (!r) return false;
    if (r.index >= start) {
      return true;
    }
    return false;
  },
});

AuditEditorFunction.injectFun({
  callName: "TOBOOLEAN",
  name: "转布尔",
  group: "通用函数",
  handler(v) {
    return !!this.$$callFuncArg(v);
  },
});
AuditEditorFunction.injectFun({
  callName: "TODOUBLE",
  name: "转双精度浮点",
  group: "通用函数",
  handler(str) {
    return parseFloat(this.$$callFuncArg(str));
  },
});
AuditEditorFunction.injectFun({
  callName: "TOLONG",
  name: "转长整型",
  group: "通用函数",
  handler(str) {
    return parseInt(this.$$callFuncArg(str));
  },
});
AuditEditorFunction.injectFun({
  callName: "TONUMBER",
  name: "转长整型",
  group: "通用函数",
  handler(v) {
    v = Number(this.$$callFuncArg(v));
    if (_.isNaN(v)) return 0;
    return v;
  },
});
AuditEditorFunction.injectFun({
  callName: "TRIM",
  name: "去空格",
  group: "通用函数",
  handler(str) {
    return (
      this.$$callFuncArg(str)
        ?.trim()
        ?.replace(/\s{2,}/g, "") ?? ""
    );
  },
});
AuditEditorFunction.injectFun({
  callName: "TRUNC",
  name: "向下取整",
  group: "通用函数",
  handler(num) {
    return Math.trunc(this.$$callFuncArg(num));
  },
});
AuditEditorFunction.injectFun({
  callName: "UPPER",
  name: "转大写",
  group: "通用函数",
  handler(str) {
    return this.$$callFuncArg(str).toLocaleUpperCase() ?? "";
  },
});
AuditEditorFunction.injectFun({
  callName: "VERIFYCH",
  name: "中文验证",
  group: "通用函数",
  handler(target, minNumber, mateText, state) {
    target = this.$$callFuncArg(target);
    minNumber = this.$$callFuncArg(minNumber);
    mateText = this.$$callFuncArg(mateText);
    state = this.$$callFuncArg(state);
    if (!target) {
      return false;
    }
    let isMinNumber = true;
    let isAllChinese = true;
    let isMateText = true;
    if (minNumber > 0) {
      let isNum = 0;
      for (let i = 0; i < target.length; i++) {
        if (/^[\u4e00-\u9fa5]$/.test(target.charAt(i))) {
          isNum++;
        }
      }
      isMinNumber = isNum >= minNumber;
    }
    if (mateText) {
      isMateText = target.includes(mateText);
    }
    if (state == 1) {
      isAllChinese = /^[\u4e00-\u9fa5]+$/.test(target);
    }
    return isMinNumber && isAllChinese && isMateText;
  },
});

AuditEditorFunction.injectFun({
  callName: "URL_QUERY",
  name: "获取URL地址参数",
  group: "通用函数",
  handler(key) {
    key = this.$$callFuncArg(key);
    return this.$queryString[key] || null;
  },
});

//--------------通用函数（前端函数）--------------

AuditEditorFunction.injectFun({
  callName: "UNABLEREPORT",
  name: "禁用",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    args.forEach((arg) => {
      if (this.$$isGetCtrl(arg)) {
        let { component } = arg;
        if (component) {
          component.disabled = true;
        }
      }
    });
  },
});

AuditEditorFunction.injectFun({
  callName: "ABLEREPORT",
  name: "取消禁用",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    args.forEach((arg) => {
      if (this.$$isGetCtrl(arg)) {
        let { component } = arg;
        if (component) {
          component.disabled = false;
        }
      }
    });
  },
});

AuditEditorFunction.injectFun({
  callName: "UNENABLE",
  name: "只读",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    args.forEach((arg) => {
      if (this.$$isGetCtrl(arg)) {
        let { component } = arg;
        if (component) {
          component.readOnly = true;
        }
      }
    });
  },
});

AuditEditorFunction.injectFun({
  callName: "ENABLE",
  name: "取消只读",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    args.forEach((arg) => {
      if (this.$$isGetCtrl(arg)) {
        let { component } = arg;
        if (component) {
          component.readOnly = false;
        }
      }
    });
  },
});

AuditEditorFunction.injectFun({
  callName: "HIDDEN",
  name: "隐藏",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    args.forEach((arg) => {
      if (this.$$isGetCtrl(arg)) {
        let { component } = arg;
        if (component) {
          component.visible = false;
        }
      }
    });
  },
});

AuditEditorFunction.injectFun({
  callName: "JUMP",
  name: "跳转元素",
  group: "通用函数",
  handler(arg) {
    if (!this.$$isFieldObj(arg)) {
      return;
    }
    const { isSubTable, subTableName, field, tableName } = arg;
    let formName = `${tableName}.${field}`;
    if (isSubTable) {
      let subTabelRowHash = subTableData[this[`${subTableName}.$hash`]];
      formName = `${subTableName}.${field}-${subTabelRowHash}`;
    }
    let target = $(this.$vm.$el).find(`[form-name="${formName}"]`);
    if (!target?.[0]) {
      console.warn(`找不到【${formName}】元素`);
      return;
    }
    target[0].scrollIntoView({
      behavior: "auto",
      block: "center",
      inline: "center",
    });
  },
});

AuditEditorFunction.injectFun({
  callName: "UNHIDDEN",
  name: "取消隐藏",
  group: "通用函数",
  handler(...args) {
    args = args.map((exp) => this.$$callFuncArg(exp));
    args.forEach((arg) => {
      if (this.$$isGetCtrl(arg)) {
        let { component } = arg;
        if (component) {
          component.visible = true;
        }
      }
    });
  },
});

AuditEditorFunction.injectFun({
  callName: "ENABLE_SELECT",
  name: "下拉框可选",
  group: "通用函数",
  handler(...args) {
    let [arg] = args.map((exp) => this.$$callFuncArg(exp));
    if (this.$$isGetCtrl(arg) && this.$$isItemsCtrl(arg)) {
      arg.needDisabledOptions = "";
    }
  },
});

AuditEditorFunction.injectFun({
  callName: "UNENABLE_SELECT",
  name: "下拉框不可选",
  group: "通用函数",
  handler(...args) {
    let [arg, values] = args.map((exp) => this.$$callFuncArg(exp));
    if (this.$$isGetCtrl(arg) && this.$$isItemsCtrl(arg) && values) {
      arg.needDisabledOptions = values || "";
    }
  },
});

AuditEditorFunction.injectFun({
  callName: "POP_WINDOW",
  name: "弹窗函数",
  group: "通用函数",
  handler(...args) {
    // state 1普通弹窗；2读秒弹窗；3浮窗
    let [message, state, s] = args.map((exp) => this.$$callFuncArg(exp));
    if (state == 1) {
      dsf.layer.alert({
        message,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  },
});
AuditEditorFunction.injectFun({
  callName: "EVENT_WINDOW",
  name: "弹窗并根据确定取消执行操作",
  group: "通用函数",
  handler(...args) {
    let [message, thenFn, catchFn] = args.map((exp) => this.$$callFuncArg(exp));
    dsf.layer
      .confirm({ message, showClose: false })
      .then(() => {
        dsf.isFunction(thenFn) && thenFn();
      })
      .catch(() => {
        dsf.isFunction(catchFn) && catchFn();
      });
  },
});

AuditEditorFunction.injectFun({
  callName: "DK202_MONTH_ADD",
  name: "报表月度累计",
  group: "DK202特殊函数",
  handler() {
    return;
  },
});

AuditEditorFunction.injectFun({
  callName: "DK202_JJZW_VERIFY",
  name: "报表经济作物校验",
  group: "DK202特殊函数",
  handler() {
    return;
  },
});
AuditEditorFunction.injectFun({
  callName: "IF_WLB",
  name: "跨调查对象从物理表取数",
  group: "后端函数",
  handler() {
    return;
  },
});
AuditEditorFunction.injectFun({
  callName: "WLB_FILTER",
  name: "跨调查对象从物理表过滤数据",
  group: "后端函数",
  handler() {
    return;
  },
});
AuditEditorFunction.injectFun({
  callName: "BGQ_SUB_ML_SETVALUE",
  name: "挎报告期摘抄二维不定长",
  group: "填报规则函数",
  handler(...args) {
    let [setTarget, getTarget, offset] = args.map((exp) =>
      this.$$callFuncArg(exp)
    );
    let subTableList =
      this.$crossTableData?.subTableData?.[getTarget?.subTableName]?.[offset] ||
      [];
    let row = subTableList.find(
      (row) =>
        row[`${getTarget.subTableName}.stats_meta_id`] ==
        this.$event_args?.data?.[`${setTarget.subTableName}.stats_meta_id`]
    );
    let setTargetValue = row?.[`${getTarget?.subTableName}.${getTarget.field}`];
    if (!dsf.isUnDef(setTargetValue)) {
      this.$vm.$set(
        this.$event_args.data,
        `${setTarget?.subTableName}.${setTarget.field}`,
        setTargetValue
      );
    }
    return;
  },
});

AuditEditorFunction.injectFun({
  callName: "ADD_EVENT_LISTENER",
  name: "监听事件",
  group: "事件函数",
  handler(exp1, exp2) {
    exp1 = this.$$callFuncArg(exp1);
    let auditUnWacths = this.$vm.$auditUnWacths;
    if (!auditUnWacths) {
      auditUnWacths = this.$vm.$auditUnWacths = {};
    }
    let unWacthKey = `${this.$subExpressionId}#${exp1}`;
    let wacthKey = exp1;
    if (dsf.isFunction(auditUnWacths[unWacthKey])) {
      auditUnWacths[unWacthKey]();
    }
    this.$vm.$on(wacthKey, exp2);
    auditUnWacths[unWacthKey] = () => {
      this.$vm.$off(wacthKey, exp2);
      exp2 = null;
    };
    return;
  },
});

AuditEditorFunction.injectFun({
  callName: `ADD_EVENT_LISTENER("STATS_DIRECTORY_SUB_TABLE_ADD_ROW",)`,
  name: "带目录不定长新增行事件",
  group: "事件函数",
  afterContent: {
    value: "",
    position: -1,
  },
  handler() {
    return;
  },
});

//统一社会信用代码
function Tyshyxdm() {
  this.firstarray = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  this.firstkeys = [3, 7, 9, 10, 5, 8, 4, 2];
  this.secondarray = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "J",
    "K",
    "L",
    "M",
    "N",
    "P",
    "Q",
    "R",
    "T",
    "U",
    "W",
    "X",
    "Y",
  ];
  this.secondkeys = [
    1,
    3,
    9,
    27,
    19,
    26,
    16,
    17,
    20,
    29,
    25,
    13,
    8,
    24,
    10,
    30,
    28,
  ];
  this.verify = function (str) {
    var code = str.toUpperCase();
    if (code.length != 18) {
      return false;
    }
    var reg = /^\w\w\d{6}\w{9}\w$/;
    if (!reg.test(code)) {
      return false;
    }
    reg = /^[1,5,9,Y]\w\d{6}\w{9}\w$/;
    if (!reg.test(code)) {
      return false;
    }
    reg = /^(11|12|13|19|51|52|53|59|91|92|93|Y1)\d{6}\w{9}\w$/;
    if (!reg.test(code)) {
      return false;
    }
    reg = /^(11|12|13|19|51|52|53|59|91|92|93|Y1)\d{6}\w{9}\w$/;
    if (!reg.test(code)) {
      return false;
    }
    var firstkey = this.calc(
      code.substr(8),
      this.firstarray,
      this.firstkeys,
      11
    );
    var firstword;
    if (firstkey < 10) {
      firstword = firstkey;
    }
    if (firstkey == 10) {
      firstword = "X";
    } else if (firstkey == 11) {
      firstword = "0";
    }
    if (firstword != code.substr(16, 1)) {
      return false;
    }
    var secondkey = this.calc(code, this.secondarray, this.secondkeys, 31);
    var secondword = this.secondarray[secondkey];
    if (!secondword || secondword != code.substr(17, 1)) {
      return false;
    }
    var word = code.substr(0, 16) + firstword + secondword;
    if (code != word) {
      return false;
    }
    return true;
  };
  this.calc = function (code, array1, array2, b) {
    var count = 0;
    for (var i = 0; i < array2.length; i++) {
      var a = code[i];
      count += array2[i] * array1.indexOf(a);
    }
    return b - (count % b);
  };
}
